export const DYNAMIC_SECTION_PAGES = ['stoploss','productset'];

export const PAGE_TYPE_CONSTANTS = {
    'stoploss':{
        heading:' Stop Loss Rule'
    },
    'productset':{
        heading: ' Smart Product Set'
    }
}